'use client'

import { useSyncExternalStore } from 'react'
import Link from 'next/link'
import { dismissTtsNotice, getTtsNotice, subscribeTtsNotice } from '@/lib/speak'
import { FREE_WEEKLY_TTS_LIMIT } from '@/lib/chat'

// Один раз за сессию страницы: когда озвучка Google упёрлась в недельный
// лимит и кнопка 🔊 перешла на голос браузера. Без этого человек решит, что
// приложение сломалось или «всегда так звучало» (обсуждение 2026-09-15).
// Стоит в layout рядом с TrPopoverHost. Inline-стили — устаревший CSS на телефоне.
export function TtsLimitToast() {
  const shown = useSyncExternalStore(subscribeTtsNotice, getTtsNotice, () => false)
  if (!shown) return null
  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        left: 12,
        right: 12,
        bottom: 'calc(env(safe-area-inset-bottom, 0px) + 12px)',
        zIndex: 60,
        margin: '0 auto',
        maxWidth: 520,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        padding: '12px 14px',
        borderRadius: 16,
        border: '1.5px solid var(--tk-fire)',
        background: 'linear-gradient(165deg, oklch(0.32 0.06 254 / 0.98) 0%, oklch(0.18 0.035 254 / 0.99) 100%)',
        boxShadow: '0 14px 32px -12px oklch(0 0 0 / 0.7)',
        color: 'oklch(0.92 0.03 240)',
        fontSize: 14,
        lineHeight: 1.45,
      }}
    >
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 700, color: 'var(--tk-gold)' }}>Озвучка Google на этой неделе закончилась</div>
        <div style={{ marginTop: 2 }}>
          Новые фразы ({FREE_WEEKLY_TTS_LIMIT} в неделю) теперь читает голос вашего устройства. Слова уроков звучат как прежде, лимит обновится в понедельник.
        </div>
        <Link href="/plans" onClick={dismissTtsNotice} className="tk-pill tk-pill--sm tk-pill--gold" style={{ marginTop: 6 }}>
          Больше AI в подписке
        </Link>
      </div>
      <button type="button" aria-label="Закрыть" onClick={dismissTtsNotice} className="tk-back-btn">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="15" height="15">
          <path d="M6 6l12 12M18 6 6 18"></path>
        </svg>
      </button>
    </div>
  )
}
